module.exports = __webpack_public_path__ + "img/masterventures.40a6858b.png";